/** Perfil e identidad de la clínica (plastica|fisio|dental|estetica).
 * Lo expone GET /api/settings (`clinic_profile` y `clinic_name`). Se cachea
 * en memoria: no cambia durante la sesión. */
import { api } from './api';

let cached = null;

async function load() {
  if (cached) return cached;
  try {
    const r = await api.get('/api/settings');
    cached = {
      profile: r.data?.clinic_profile || 'plastica',
      clinicName: r.data?.clinic_name || '',
    };
  } catch {
    cached = { profile: 'plastica', clinicName: '' };
  }
  return cached;
}

export async function getClinicProfile() {
  return (await load()).profile;
}

export async function getClinicName() {
  return (await load()).clinicName;
}

/** Pone el nombre real de la clínica en la pestaña del navegador
 *  («ClinicPilot · Clínica Dental Demo»). */
export async function applyDocumentTitle() {
  const { clinicName } = await load();
  if (clinicName) document.title = `ClinicPilot · ${clinicName}`;
}
